import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_TEMPLATES, res.data)
  })
)

export const syncFromMeta = () => (
  services.syncFromMeta()
)

export const save = async ({ commit }, payload) => {
  const res = await services.createTemplate(payload)
  commit(types.SET_TEMPLATE, res.data.data)
  return res
}

export const update = async ({ commit }, { id, payload }) => {
  const res = await services.updateTemplate(id, payload)
  commit(types.SET_TEMPLATE, res.data.data)
  return res
}

export const deleteTemplate = async ({ commit }, id) => {
  const res = await services.deleteTemplate(id)
  return res
}

export const refreshStatus = async ({ commit }, id) => {
  const res = await services.refreshStatus(id)
  commit(types.SET_TEMPLATE, res.data.data)
  return res
}
